import React, { useState, useEffect, useContext} from "react"

import {
  Box,
} from '@material-ui/core';

import NewCertifChart from "../NewCertifChart"

import logoBlanc from "../../../images/logoBlanc-pdf.png"
import logoNoir from "../../../images/logoNoir-pdf.png"

let pageDimensions = {width : "1250px", height:"1768px"}

const LegendSvg = ({color}) => {
  return (
    <svg width="52" height="60" viewBox="0 0 52 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M51.4648 15.2881V44.7109L25.9844 59.4229L0.503906 44.7109V15.2881L25.9844 0.576172L51.4648 15.2881Z" fill={color} fillOpacity="0.2" stroke={color}/>
    </svg>
  )
}

const TopForPage = ({page, pageTot}) => {
  return (
    <Box sx={{
      display:"flex",
      justifyContent:"space-between",
      position:"relative",
      marginBottom:"22px",
    }}>
      <img src={logoNoir} style={{width:"187px", height:"35px"}}/>
      <Box sx={{textAlign:"right"}}>
        <Box sx={{
          fontSize:"30px"
        }}>
          Rapport The Lab
        </Box>
        <Box sx={{
          fontSize:"16px",
          marginTop:"4px",
        }}>
          Page {page} sur {pageTot}
        </Box>
      </Box>
      <Box sx={{
        position:"absolute",
        bottom:"-22px",
        right:"-75px",
        width:"600px",
        height:"2px",
        background:"#D4D4D4",
      }}/>
    </Box>
  )
}

const Rapport = React.forwardRef(({ user, data, getDatasForChart }, ref) => {

  /*let labelsCategories = ['communication','efficacite','leadership']
  let softSkillsByFamily = actScan?.finalSoftSkills?.sort((a, b) => a?.family?.localeCompare(b?.family));

  let userResult = actScan?.userResults?.find((el) => el.userID === user.userID)
  let resultFin = JSON.parse(userResult?.resultFin)

  softSkillsByFamily?.forEach((skill) => {
    if (resultFin[skill.key]) {
      skill.score = resultFin[skill.key]?.score
    } else {
      skill.score = 0
    }
  })

  console.log(softSkillsByFamily)*/

  return (
    <Box sx={{
      height:"1000px",
      //overflowX:"auto",
      overflowY:"auto",
      position:"absolute",
      top:"99999px",
      //top:"0px",
      left:0,
      zIndex:9999999,
    }}>
      <Box ref={ref} sx={{}}>
        {/* PREMIERE PAGE */}
        <Box sx={{
          width:pageDimensions?.width,
          height:pageDimensions?.height,
          background:"#2F2F2F",
          padding:"85px",
          color:"white",
        }}>
          <img src={logoBlanc} style={{width:"187px", height:"35px"}}/>
          <Box sx={{marginTop:"190px", fontSize:"102px"}}>
            Rapport recruteur
          </Box>
          <Box sx={{
            marginTop:"57px",
            height:"2px",
            width:"500px",
            background:"#53D769",
          }}/>
        </Box>
        {/* END PREMIERE PAGE */}

        <Box sx={{
          width:pageDimensions?.width,
          height:pageDimensions?.height,
          background:"#FAF8F6",
          color:"black",
          padding:"35px 75px",
        }}>
          <TopForPage
            page={2}
            pageTot={7}
          />

          <Box sx={{
            marginTop:"130px"
          }}>
            <Box sx={{ fontSize:"52px" }}>
              Synthèse de compatibilité avec le poste
            </Box>
            <Box sx={{ marginTop:"20px", fontSize:"20px", color:"rgba(0,0,0,0.7)", lineHeight:"140%" }}>
              Cette section présente le niveau de compatibilité entre le profil comportemental du<br/>candidat et les compétences clés définies pour ce poste.
            </Box>
            <Box sx={{ marginTop:"25px", display:"flex", gap:"30px", }}>
              <Box sx={{display:"flex", gap:"16px", alignItems:"center"}}>
                <LegendSvg color="#FED030"/>
                <Box sx={{ fontSize:"18px" }}>
                  Seuil requis
                </Box>
              </Box>
              <Box sx={{display:"flex", gap:"16px", alignItems:"center"}}>
                <LegendSvg color="#4F39FF"/>
                <Box sx={{ fontSize:"18px" }}>
                  Leadership & collaboration
                </Box>
              </Box>
              <Box sx={{display:"flex", gap:"16px", alignItems:"center"}}>
                <LegendSvg color="#FF5106"/>
                <Box sx={{ fontSize:"18px" }}>
                  Innovation & communication
                </Box>
              </Box>
              <Box sx={{display:"flex", gap:"16px", alignItems:"center"}}>
                <LegendSvg color="#F390FF"/>
                <Box sx={{ fontSize:"18px" }}>
                  Efficacité opérationnelle
                </Box>
              </Box>
            </Box>
            <Box sx={{marginTop:"100px"}}>
              {/*<NewCertifChart
                datas={getDatasForChart(true)}
              />*/}
            </Box>
          </Box>
        </Box>


      </Box>
    </Box>
  )
});

export default Rapport;
